import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { HubConnectionBuilder, HttpTransportType, LogLevel, JsonHubProtocol } from '@aspnet/signalr';
import {logger} from '../logging/logger';

const log = logger('withSignalr');

export const withSignalr = options => (WrappedComponent) => {
  const { hubName, retries = 3 } = options;

  const WithSignalr = props => {
    const { access_token, dispatch, ...passThroughProps } = props;
    const [currentRetry, setCurrentRetry] = useState(0);
    const [connectionActive, setConnectionActive] = useState(false);

    const connection = new HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_API_ENDPOINT}/${hubName}`, {
        transport: HttpTransportType.WebSockets,
        accessTokenFactory: () => access_token,
        logMessageContent: process.env.REACT_APP_MODE === 'development',
        skipNegotiation: true
      })
      .configureLogging(process.env.REACT_APP_MODE === 'development' ? LogLevel.Trace : LogLevel.Warning)
      .withHubProtocol(new JsonHubProtocol())
      .build();

    useEffect(() => {
      let retryTimeout = null;
      if(!connectionActive && currentRetry < retries) {
        connection.start({ withCredentials: true })
        .then(() => {
          setCurrentRetry(0);
          setConnectionActive(true);
          retryTimeout = null;
        })
        .catch(err => {
          retryTimeout = setTimeout(() =>{
            setCurrentRetry(prev => prev + 1);
          }, 2000);
          log.error(err);
        });
      }

      return () => {
        if(connectionActive) {
          connection.stop();
        }
        if(retryTimeout) {
          clearTimeout(retryTimeout);
        }
      }
    }, [currentRetry, connection, connectionActive]);


    return (
      <WrappedComponent {...passThroughProps} signalrConnection={connection} />
    )
  }

  WithSignalr.displayName = `withSignalr(${WrappedComponent.displayName})`;

  const mapStateToProps = (state) => {
    return {
      access_token: state.oidc.user.access_token
    };
  }

  return connect(mapStateToProps)(WithSignalr);
}



